import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, HomeIcon } from "lucide-react";

export interface BreadcrumbItem {
  name: string | ReactNode;
  href: string;
}

interface BreadcrumbNavigationProps {
  items: BreadcrumbItem[];
  className?: string;
  showHome?: boolean;
}

export default function BreadcrumbNavigation({
  items,
  className = "",
  showHome = true,
}: BreadcrumbNavigationProps) {
  // Check if Home is already included in the items array
  const hasHomeInItems = items.some(item => item.href === '/');
  const shouldShowHome = showHome && !hasHomeInItems;
  return (
    <nav className={`flex ${className}`} aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-2">
        {shouldShowHome && (
          <li className="inline-flex items-center">
            <Link
              to="/"
              className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
            >
              <HomeIcon className="h-4 w-4 mr-2" />
              Home
            </Link>
          </li>
        )}

        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={item.href} className="flex items-center">
              <ChevronRightIcon className="h-4 w-4 text-muted-foreground mx-1" />
              {isLast ? (
                <span className="text-sm font-medium" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
